module.exports = __webpack_public_path__ + "img/01cb8b0.jpg";